import * as williams from "@/features/custom/williams/routes";
import { faAddressCard, faFolder, faFolderOpen } from "@fortawesome/free-regular-svg-icons";
import { faCalendar, faClipboard, faUser } from "@fortawesome/free-regular-svg-icons";
import { faClipboardUser, faDiagramProject, faHouse, faPersonChalkboard } from "@fortawesome/free-solid-svg-icons";
import { faFileLines, faStar } from "@fortawesome/free-regular-svg-icons";
import { useConfiguration } from "@/queries/configuration.queries";

export function useMenuOptions() {
  const config = useConfiguration();

  if (config.data?.qualifier?.isWilliams) {
    return [
      {
        title: "Home",
        to: "/",
        icon: faHouse,
        visible: true,
      },
      {
        title: "Dashboard",
        to: williams.getFullPath(williams.routes.dashboard.base),
        icon: faStar,
        visible: true,
      },
      {
        title: "Projects",
        to: williams.getFullPath(williams.routes.project.list),
        icon: faFolderOpen,
        visible: true,
      },
      {
        title: "Scopes of Work",
        to: williams.getFullPath(williams.routes.scopeOfWork.list()),
        icon: faFolder,
        visible: true,
      },
      {
        title: "Welders",
        to: williams.getFullPath(williams.routes.welder.list()),
        icon: faUser,
        visible: true,
      },
      {
        title: "Test Events",
        to: williams.getFullPath(williams.routes.testEvent.list),
        icon: faCalendar,
        visible: true,
      },
      {
        title: "Contractors",
        to: williams.getFullPath(williams.routes.contractor.list),
        icon: faAddressCard,
        visible: true,
      },
      {
        title: "Standard Tests",
        to: williams.getFullPath(williams.routes.standardTests.list),
        icon: faClipboard,
        visible: true,
      },
    ];
  } else {
    return [
      {
        title: "Certificates",
        to: "/certificates",
        icon: faPersonChalkboard,
        visible: Boolean(config.data?.qualifier),
      },
      {
        title: "Procedures",
        to: "/procedures",
        icon: faFileLines,
        visible: Boolean(config.data?.qualifier),
      },
      {
        title: config.data?.datasheetName ?? "Datasheets",
        to: "/datasheets",
        icon: faDiagramProject,
        visible: Boolean(config.data?.coordinator?.isAep),
      },
      {
        title: "Role Based Interface",
        to: "/rbi",
        icon: faClipboardUser,
        visible: Boolean(config.data?.coordinator),
      },
    ];
  }
}
